module.exports = __webpack_public_path__ + "static/media/zrekonstruovany-klaster.4f2e1aab.JPG";